import { Injectable } from '@angular/core';
import { ApiService, HttpResponse, HttpStatusEnum } from '@core/api';
import { IncompleteOrder, IncompleteOrderDTO } from '../interfaces';
import { LayoutMapper } from './layout.mapper';

@Injectable({ providedIn: 'root' })
export class LayoutApi {
    private readonly resourceUrl = 'orders';

    constructor(private apiService: ApiService) {}

    getIncompleteOrders(): Promise<HttpResponse<IncompleteOrder[]>> {
        return new Promise<HttpResponse<IncompleteOrder[]>>(resolve => {
            this.apiService.get(`${this.resourceUrl}/incomplete-orders`).subscribe({
                next: (res: { orders: IncompleteOrderDTO[] }) => {
                    resolve(LayoutMapper.mapGetIncompleteOrdersData(res));
                },
                error: () => {
                    resolve({ data: null, status: HttpStatusEnum.ERROR });
                },
            });
        });
    }
}
